export type PurchaseOrderApiOrderingProvider = "digikey";

export function purchaseOrderApiOrderingProvider(
  supplierName: string | null | undefined,
): PurchaseOrderApiOrderingProvider | null {
  const normalized = (supplierName ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");
  if (normalized.includes("digikey")) {
    return "digikey";
  }
  // Mouser currently supports cart preview only. Add it when order submission is implemented.
  return null;
}
